/**
 * AfterShip Estimated Delivery Date widget.
 *
 * Reads configuration from data attributes on the wrapper element:
 *   data-aftership-shop-domain — shop permanent domain
 *   data-aftership-product-id — product ID
 * and a variant-id -> should-show JSON map from the embedded
 * [data-aftership-visibility] script (computed server-side — see
 * snippets/aftership-estimated-delivery.liquid for why).
 *
 * Mounts the <aftership-aedd> custom element, loads the IIFE script,
 * and toggles visibility based on variant availability.
 */
(function () {
  const wrapper = document.getElementById('shipping-estimate-wrapper');
  if (!wrapper) return;

  const shopDomain = wrapper.getAttribute('data-aftership-shop-domain');
  const productId = wrapper.getAttribute('data-aftership-product-id');

  function mount() {
    if (window.as_aedd_inited && document.querySelector('aftership-aedd')) return;
    var target = document.getElementById('aftership-mount');
    if (!target || target.querySelector('aftership-aedd')) return;

    var el = document.createElement('aftership-aedd');
    el.className = 'aftership-container';
    el.setAttribute('app-platform', 'shopify');
    el.setAttribute('app-key', shopDomain);
    el.setAttribute('app-name', 'aftership');
    el.setAttribute('product-id', productId);
    target.appendChild(el);
  }

  // Expose mount for post-morph reinitialization
  window._asMountWidget = mount;

  // Load the AfterShip IIFE script (only once)
  if (!window._asScriptLoaded) {
    window._asScriptLoaded = true;
    var s = document.createElement('script');
    s.src = 'https://widgets.automizely.com/aftership-aedd-v2/index.iife.js';
    s.onload = function () {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mount);
      } else {
        mount();
      }
    };
    wrapper.appendChild(s);
  } else {
    // Script already loaded from a prior render; just mount
    mount();
  }

  // Re-mount after variant morph replaces the DOM
  document.addEventListener('theme:section:morph', function () {
    // Clear stale element reference so mount() creates a fresh one
    window.as_aedd_inited = false;
    mount();
  });

  // ── Variant toggle logic ──

  function readVisibilityMap(currentWrapper) {
    var scriptEl = currentWrapper.querySelector('[data-aftership-visibility]');
    if (!scriptEl) return {};
    try {
      return JSON.parse(scriptEl.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function toggleShippingWidget() {
    // Re-query wrapper each time — the element may have been replaced by a morph
    var currentWrapper = document.getElementById('shipping-estimate-wrapper');
    if (!currentWrapper) return;

    var variantSelect = document.querySelector(
      'select[name="id"], input[name="id"]:checked, input[name="id"]'
    );
    if (!variantSelect) return;

    var visibilityByVariant = readVisibilityMap(currentWrapper);
    var shouldShow = visibilityByVariant[variantSelect.value] === true;
    currentWrapper.style.display = shouldShow ? 'block' : 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', toggleShippingWidget);
  } else {
    toggleShippingWidget();
  }

  document.addEventListener('change', function (e) {
    if (e.target.name === 'id') toggleShippingWidget();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="id"]') || e.target.closest('.product-form__input')) {
      setTimeout(toggleShippingWidget, 50);
    }
  });
})();
